export default "<mat-toolbar class=\"app-footer\" color=\"primary\">\n</mat-toolbar>\n";